import React from 'react';
import { FileRejection, FileWithPath, useDropzone, Accept } from 'react-dropzone';
import { useTheme, Box, Chip, Typography, IconButton } from '@mui/material';
import { CloudUpload as CloudUploadIcon } from '@mui/icons-material';

interface IDropzoneProps {
  file: IFileUpload;
  maxSize?: number;
  accept?: Accept;
  multiple: boolean;
  fileRequirementsMessage?: string;
  fileRequirementsHelp?: string;
  onDrop?: (acceptedFiles: FileWithPath[], fileRejections: FileRejection[]) => void;
}

// AMA v2 specific dropzone (CSV + SAV)
const AmaV2Dropzone = (props: IDropzoneProps) => {
  const theme = useTheme();
  const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
    onDrop: props.onDrop,
    multiple: props.multiple,
    accept: props.accept,
    maxSize: props.maxSize,
  });

  const getContainerStyle = () => {
    let borderColor = theme.palette.grey[400];
    if (isDragAccept) borderColor = theme.palette.primary.main; else if (isDragReject) borderColor = theme.palette.error.main;
    return {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      border: '2px dashed',
      borderColor,
      borderRadius: 4,
    } as const;
  };

  return (
    <Box {...getRootProps()} sx={getContainerStyle()}>
      {/* Top */}
      <Box sx={{ alignSelf: 'center', flex: '1 1 auto', display: 'flex', flexDirection: 'column-reverse' }}>
        <Chip label={props.file.Category} size='small' />
      </Box>
      {/* Middle */}
      <Box sx={{ alignSelf: 'center', textAlign: 'center', flex: '0 0 auto', py: 0 }}>
        <input {...getInputProps()} />
        <IconButton aria-label='upload file' color='primary'>
          <CloudUploadIcon color='primary' fontSize='large' aria-hidden='true' />
        </IconButton>
      </Box>
      {/* Bottom */}
      <Box sx={{ alignSelf: 'center', textAlign: 'center', flex: '1 1 auto' }}>
        <Typography component='h6' sx={{ color: theme.palette.text.secondary, fontSize: '.8rem' }}>
          Drag & drop or
          <Typography component='span' sx={{ color: theme.palette.text.secondary, fontSize: '.8rem', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}>
            {' '}browse
          </Typography>.<br/>
          [ csv | sav ]
        </Typography>
      </Box>
    </Box>
  );
};

export default AmaV2Dropzone;
